module.exports = __webpack_public_path__ + "static/media/rojo.25afb304.jpg";